import React from 'react';

import CentralAssumptionGroupUpsertFrom from './CentralAssumptionGroupUpsertFrom';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function CentralAssumptionGroupUpsertModal({
    modalId,
    assumptionGroup,
    venueId,
    loading,
    storeUrl,
    updateUrl,
    onSuccess,
    modalRef,
    modalElement,
    deleteAttachmentUrl,
    downloadAttachmentUrl,
    canDeleteAssumption,
    canVerifyAssumption,
}) {
    const close = () => {
        modalElement.hide();
    };

    return (
        <div id={modalId} ref={modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container tw-max-w-7xl">
                <div className="modal__inner-container">
                    <ModalHeader title={assumptionGroup ? $t('Edit Central Assumptions') : $t('Create Central Assumptions')} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        {loading ? (
                            <LoadingSpinner />
                        ) : (
                            <div className="modal__form-container">
                                <CentralAssumptionGroupUpsertFrom
                                    assumptionGroup={assumptionGroup}
                                    venueId={venueId}
                                    storeUrl={storeUrl}
                                    updateUrl={updateUrl}
                                    deleteAttachmentUrl={deleteAttachmentUrl}
                                    downloadAttachmentUrl={downloadAttachmentUrl}
                                    canDeleteAssumption={canDeleteAssumption}
                                    canVerifyAssumption={canVerifyAssumption}
                                    onCancel={close}
                                    onSuccess={() => {
                                        onSuccess();
                                        close();
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
